var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-window',{model:{value:(_vm.slider),callback:function ($$v) {_vm.slider=$$v},expression:"slider"}},_vm._l((_vm.categories),function(category){return _c('h-items-list',_vm._b({key:category.id,on:{"change":function($event){return _vm.$emit('change')}}},'h-items-list',category,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }